const id ={
    navbar : {
        home : "Home",
        aboutMe : "Tentang Saya",
        education : "Pendidikan",
        employment : "Pengalaman Kerja",
        achievements : "Penghargaan",
        research    : "Penelitian",
        projects : "Projek",
        collab : "Kolaborasi",
    },
    home : {
        desc : "Halo semua! Selamat datang di homepage pribadi aku. Kenalin namaku Eduardo Iglesius. Homepage ini adalah salah satu proyek pribadi aku, ntar bakalan dipake sebagai portofolio digital kayak LinkedIn. Di laman ini, aku bakalan membagikan pencapaian dan berbagai proyek yang udah aku buat, baik sendiri maupun bareng teman yang lain. Semoga kalian enjoy dengan laman ini. Untuk informasi lebih lanjut, silakan scroll ke paling bawah. Enjoy your visit!",
        news : {
            hackathon : "Menerima Excelence Award dari lomba Hackathon Track Job",
            masterHandai : "Mulai S2 di Osaka University",
            graduateHandai : "Lulus S1 dari Osaka University",
            mextMaster : "Menerima beasiswa MEXT untuk S2",
            cChannel : "Mulai bekerja sebagai Web Developer di C-Channel Jepang",
            helloSensei : "Mulai bekerja sebagai guru bahasa Indonesia di Hello Sensei Jepang",
            wasabi : "Mulai bekerja sebagai translator di Mori Kosan",
            headInternal : "Menjadi ketua internal PPI-ON",
            memberInternal : "Menjadi anggota internal PPI-ON",
            bachelorHandai : "Mulai S1 di Osaka University",
            jlc : "Mulai sekolah bahasa Jepang di Japanese Language Center for International Students",
            mextBachelor : "Menerima beasiswa MEXT untuk S1",
            advancedRobotics : "Mempublikasi 1 paper di Advanced Robotics",
            robomech : "Melakukan Presentasi di ROBOMECH 2025 di Yamagata",
            moneyForward : "Memulai internship di Money Forward",
        },
    },
    aboutMe : {
        aboutMe : "Tentang Saya",
        name : "Nama",
        age : "Umur",
        nationality : "Kenegaraan",
        occupation : "Pekerjaan",
        hobby : "Hobi",
        language : "Bahasa",
        interest : "Ketertarikan",
        indonesia : "Indonesia",
        masterStudent : "Mahasiswa S2"
    },
    education : {
        education : "Pendidikan",
        westKalimantan : "Kalimantan Barat",
        westJawa : "Jawa Barat",
        indonesia : "Indonesia",
        elementary_title : "SDK Immanuel Pontianak",
        junior_title : "SMPK Immanuel Pontianak",
        senior_title : "SMAK Immanuel Pontianak",
        itb_title : "Institut Teknologi Bandung",
        jlc_title : "Japanese Language Center for International Students",
        handai_title : "Osaka University",
        elementary : "SD",
        junior : "SMP",
        senior : "SMA",
        itb_desc : "S1. Hanya berkuliah beberapa bulan di sini sebelum mendapatkan beasiswa ke Jepang.",
        osaka : "Osaka",
        tokyo : "Tokyo",
        japan : "Jepang",
        jlc : "Sekolah bahasa Jepang. Sekolah persiapan bahasa Jepang sebelum berkuliah di Jepang.",
        handai_under : "S1",
        handai_master : "S2",
    },
    employment : {
        employment : "Pengalaman Kerja",
        wasabi_title : "Translator Bahasa Indonesia-Inggris-Jepang",
        wasabi_loc : "Mori Kosan Co,. Ltd. Osaka, Jepang",
        wasabi_desc : "Menerjemahkan artikel, berita, dan caption SNS antara bahasa Indonesia, Inggris, dan Jepang. Hanya untuk jangka pendek dikarenakan jadwal universitas yang ketat.",
        hello_title : "Guru Bahasa Indonesia",
        hello_loc : "Hello Sensei, Jepang",
        hello_desc : "Mengajar orang Jepang dari berbagai rentang usia dalam bahasa Indonesia.",
        web_title : "Web Developer",
        web_loc : "C-channel. Tokyo, Jepang",
        web_desc : "Mengembangkan halaman dengan mendesain halaman menggunakan React dan TypeScript serta mengelola database menggunakan MongoDB dan MySQL.",
        teamlab_title : "Front End Developer",
        teamlab_loc : "TeamLab. Tokyo, Jepang",
        teamlab_desc : "Merancang halaman menggunakan React dan Next.js. Membuat navigasi lokal untuk halaman yang mengikuti halaman saat digulir, dan menambahkan fungsi untuk mengurutkan data yang ditampilkan di halaman",
        amazon_title : "Software Development Engineer Intern",
        amazon_loc : "Amazon. Tokyo, Jepang",
        amazon_desc : "Mendapatkan kesempatan untuk belajar bagaimana menggunakan layanan Amazon AWS untuk membuat layanan lain, sambil juga memahami lebih dalam tentang prinsip kepemimpinan di Amazon.",
        mf_title : "Software Engineer Intern",
        mf_loc : "Money Forward, Inc. Tokyo, Japan",
        mf_desc : "Mengembangkan Front End dan Back End, serta membuat unit test, integration test, dan E2E test."
    },
    month : {
        present : "Sekarang",
        january : "Januari",
        february : "Februari",
        march : "Maret",
        april : "April",
        may : "Mei",
        june : "Juni",
        july : "Juli",
        august : "Agustus",
        september : "September",
        october : "Oktober",
        november : "November",
        december : "Desember",
    },
    achievements : {
        achievements : "Penghargaan",
        key : {
            name : "Nama",
            year : "Tahun",
            desc : "Ket",
        },
        hackathon_desc : "Penghargaan dari Track Job, diberikan kepada tim atas ide, pengimplementasian dan presentasi secara keseluruhan yang diselenggarakan selama 2 minggu.",
        gakubusho_desc : "Penghargaan dari Osaka University, diberikan kepada satu mahasiswa berprestasi dari setiap jurusan di Osaka University",
        mextMaster_desc : "Beasiswa yang dibiayai oleh Kementerian Pendidikan, Kebudayaan, Olahraga, Ilmu Pengetahuan dan Teknologi Jepang (MEXT), mendukung mahasiswa asing yang belajar di Jepang. Beasiswa ini mencakup biaya kuliah, menyediakan uang saku bulanan, dan mencakup biaya perjalanan pulang-pergi Jepang",
        tpbsho_desc : "Penghargaan dari Osaka University, diberikan kepada mahasiswa berpresetasi di tahun pertama. Setiap tahunnya, sekitar 50 mahasiswa dari lebih dari 3000 mahasiswa dari semua fakultas dipilih, berdasarkan prestasi mereka di akhir tahun kedua",
        mextBach_desc : "Beasiswa yang dibiayai oleh Kementerian Pendidikan, Kebudayaan, Olahraga, Ilmu Pengetahuan dan Teknologi Jepang (MEXT), mendukung mahasiswa asing yang belajar di Jepang. Beasiswa ini mencakup biaya kuliah, menyediakan uang saku bulanan, dan mencakup biaya perjalanan pulang-pergi Jepang",
        other_desc : "Semua penghargaan lain yang aku terima dari SD sampai SMA. Semua ditampilkan dalam gambar."
    },
    research : {
        research : "Penelitian",
        detail : "Lebih lengkap"
    },
    project : {
        title : "Project Kecil Edo",
        key : {
            name : "Nama",
            year : "Tahun",
            desc : "Ket",
        },
        bi_name : "Bad Interface",
        bi_desc : "Ide bad interface untuk halaman login, nama dapat diatur menggunakan scroll bar dan PIN dapat diatur dengan menggunakan russian roullete.",
        hp_name : "Homepage",
        hp_desc : "Homepage ini, digunakan sebagai portofolio digital yang mirip dengan LinkedIn. Di web ini, aku bakalan ngebagiin pencapaian dan berbagai proyek yang aku dengan style-ku sendiri.",
        todo_name : "To-Do-List Android App",
        todo_desc : "Aplikasi Android untuk memasukkan daftar tugas. Pengguna dapat memilih tanggal dan aktivitas mereka sendiri. Pengguna juga dapat menghapus aktivitas yang telah selesai. Proyek ini dibuat sebagai tahap awal perjalan app development-ku",
        calculator_name : "Calculator Web Service",
        calculator_desc : "Layanan web kalkulator sederhana di mana pengguna dapat melakukan perhitungan dasar. Proyek ini dibuat sebagai tahap awal web dev-ku.",
    },
    collab : {
        title : "Kolaborasi",
        key : {
            name : "Nama",
            year : "Tahun",
            desc : "Ket",
        },
        image_name : "Automatic Image Cropper",
        image_desc : "Program computer vision dengan gambar sebagai input, kemudian program akan langsung memotong objek kuadrilateral utama dalam gambar dan mencetaknya sebagai gambar baru. Berkolaborasi dengan : 西田 直生, 忠谷 晃佑、北村 祐稀.",
        vr_name : "脱出迷路",
        vr_desc : "Game VR 1 vs 1 antara dua pemain. Satu pemain memainkan peran sebagai Game Master, mengendalikan labirin komputer. Satu pemain lagi berperan sebagai pemain dalam labirin menggunakan kacamata VR. Tujuan pemain dalam labirin adalah untuk melarikan diri dari labirin dengan mengumpulkan kunci dan berbagai item dalam batas waktu, sambil menghindari jebakan yang disiapkan oleh Game Master dan menghindari monster yang mengintai di dalamnya. Berkolaborasi dengan : 西 滉平, 年藤 悠歩, 佐⼭ 幸翼, 玉置 文人.",
        hackathon : "Sebuah aplikasi handphone di mana pengguna dapat menggunakan kamera HP untuk meng-scan bill pada saat jalan-jalan dan dapat mengatur jumlah uang yang diperlukan masing-masing orang. Berkolaborasi dengan : 西 滉平, 吉崎 響, 和坂 優佑, 丸山 結, Buamanee Thanpimon.",
        ivrc : "Projek VR di mana pengguna dapat masuk ke dalam lukisan dan melukis di dalam dunia lukisan dengan menggunakan benda-benda yang disediakan di dalam. Berkolaborasi dengan : Junshu An, Buamanee Thanpimon, Toma Oya, Lee Gayeon, Chou",
        uroom : "Sistem web untuk melakukan reservasi ruangan. Sistem web ini mengimplementasikan frontend, backend, dan database agar bisa dengan mudah dikembangkan ke depan. Berkolaborasi dengan Junshu An."
    },
    footer : {
        contact : "Kontak",
        professional : "Platform Professional",
        personal : "Platform Personal",
        credits : "Kredit"
    }
}

export default id;